
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Creneau from '@/extend/classes/Creneau';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeCreneau' })

export default class storeCreneau extends VuexModule {
  // States
  private reccords: Creneau[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get creneauLoading (): boolean {
    return this.dataLoading;
  }
  private get creneauRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get creneauLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewCreneau() {
    return (): Creneau => { 
      return this.getCreneau(0, true);
    }
  }

  
  public get getCreneau () {
    return (id: number, canCreate = false): Creneau => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Creneau can't be 0")
        return new Creneau();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Creneau();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Creneau.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromCreneau(data.reccords[0] as Creneau);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listCreneau (): Creneau[] {
    return this.reccords;
  }

  public get listConfigCreneau (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mCreneauRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mCreneauClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mCreneauLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mCreneauLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Creneau.fromJson(reccord as Creneau));
    })
    Creneau.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mCreneauConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mCreneauCreated (obj: Creneau): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareCreneau(obj)) {
          api.fromCreneau(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareCreneau(obj)) {
            api.fromCreneau(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mCreneauUpdated (obj: Creneau): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareCreneau(obj)) {
          api.fromCreneau(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mCreneauDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerCreneau (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.creneauRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerCreneau(this.creneauCreated, this.creneauUpdated, this.creneauDeleted);
          this.mCreneauRegistered();
        } else {
          setTimeout(() => resolve(this.registerCreneau(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.creneauLoading && !this.creneauLoaded) {
          this.mCreneauLoading(true);
          return Creneau.list(filter)
            .then((data: ListData) => {
              this.mCreneauLoaded(data);
              this.mCreneauLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredCreneau (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.creneauLoading) {
        this.mCreneauLoading(true);
        return Creneau.list(filter)
          .then((data: ListData) => {
            this.mCreneauLoaded(data);
            this.mCreneauLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createCreneau (obj: Creneau): Promise<Creneau> {
    return new Promise((resolve, reject) => {
      return Creneau.fromJson(obj).createForStoreCreneau()
        .then((reccords) => {
          this.mCreneauCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateCreneau (obj: Creneau): Promise<Creneau> {
    return new Promise((resolve, reject) => {
      return Creneau.fromJson(obj).updateForStoreCreneau()
        .then((reccords) => {
          this.mCreneauUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteCreneau (obj: Creneau): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Creneau.fromJson(obj).deleteForStoreCreneau()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mCreneauDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private creneauCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mCreneauConfigUpdated(config)
    const obj = objConfig.obj as Creneau;
    this.mCreneauCreated(Creneau.fromJson(obj));
  }

  @Action
  private creneauUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mCreneauConfigUpdated(config)
    const obj = objConfig.obj as Creneau;
    this.mCreneauUpdated(Creneau.fromJson(obj));
  }

  @Action
  private creneauDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Creneau;
    this.mCreneauDeleted(obj.id);
  }
}
